window.addEventListener('scroll', () => {
    const stats = document.querySelectorAll('.c-stat');
    for (let i = 0; i < stats.length; i += 1) {
        const position = stats[i].getBoundingClientRect();
        const statItems = stats[i].querySelectorAll('.item');
        if (position.top < window.innerHeight && position.bottom >= 0) {
            statItems.forEach((e, j) => {
                setTimeout(() => {
                    e.classList.add('show');
                }, j * 500);
            });
        }
    }
});
